import React from 'react';
import { Menu, X, Home, Book, Feather, Mail } from 'lucide-react';
import { NavItem } from '../types';
import { Link, useLocation } from 'react-router-dom';

const Navigation: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const location = useLocation();

  const navItems: NavItem[] = React.useMemo(() => [
    { title: 'Accueil', href: '/', icon: <Home size={20} /> },
    { title: 'Les Livres', href: '/books', icon: <Book size={20} /> },
    { title: "L'autrice", href: '/author', icon: <Feather size={20} /> },
    { title: 'Contact', href: '/contact', icon: <Mail size={20} /> },
  ], []);

  React.useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  return (
    <nav 
      className="bg-white/90 backdrop-blur-sm shadow-lg fixed w-full z-50"
      role="navigation"
      aria-label="Menu principal"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link 
              to="/" 
              className="text-2xl font-bold text-cancun-purple"
              aria-label="Accueil - Jessica Ferramora"
            >
              Jessica Ferramora
            </Link>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => {
              const isActive = location.pathname === item.href || 
                (item.href === '/books' && location.pathname.startsWith('/book'));
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`${
                    isActive
                      ? 'text-cancun-sunset'
                      : 'text-cancun-purple hover:text-cancun-turquoise'
                  } transition-colors duration-200 flex items-center space-x-2 group`}
                  role="menuitem"
                  aria-current={isActive ? 'page' : undefined}
                >
                  <span className="group-hover:scale-110 transition-transform duration-200">
                    {item.icon}
                  </span>
                  <span>{item.title}</span>
                </Link>
              );
            })}
          </div>

          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-cancun-purple hover:text-cancun-turquoise transition-colors duration-200"
              aria-expanded={isOpen}
              aria-controls="mobile-menu"
              aria-label={isOpen ? "Fermer le menu" : "Ouvrir le menu"}
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div 
          className="md:hidden"
          id="mobile-menu"
          role="menu"
        >
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white">
            {navItems.map((item) => {
              const isActive = location.pathname === item.href || 
                (item.href === '/books' && location.pathname.startsWith('/book'));
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`${
                    isActive
                      ? 'text-cancun-sunset'
                      : 'text-cancun-purple'
                  } block px-3 py-2 text-base font-medium hover:text-cancun-turquoise flex items-center space-x-3`}
                  role="menuitem"
                  aria-current={isActive ? 'page' : undefined}
                >
                  <span>{item.icon}</span>
                  <span>{item.title}</span>
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;